import axios from 'axios'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'

import { useEffect } from 'react'

function OptOutComplete() {
    useEffect(() => {
        Loading.standard('Opting you out...')

        const searchParams = new URLSearchParams(window.location.search)
        const email = searchParams.get('email')

        axios
            .post(`https://case-delivery.sentinellegal.co.uk/multibureau-optout`, { email })
            // .post(`http://localhost:8080/multibureau-optout`, { email })
            .then((response) => {
                console.log(response)
                Loading.remove()
            })
            .catch((e) => {
                console.log('error:', e)
                Loading.remove()
                Report.failure(
                    'Error',
                    'We encountered an error opting you out, please contact support@sentinellegal.co.uk',
                    'OK'
                )
            })
    })

    return (
        <div
            style={{
                textAlign: 'center',
                color: '#434343',
                marginTop: '30px',
                marginBottom: '0px',
                fontWeight: '600',
                letterSpacing: '1px',
                maxWidth: '600px',
                margin: '0 auto',
                minHeight: 'calc(60vh - 100px)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <h2
                style={{
                    color: '#434343',
                    textAlign: 'center',
                    marginTop: 0,
                    marginBottom: '30px',
                }}
            >
                Opt Out Complete!
            </h2>
            <p
                style={{
                    color: '#434343',
                    textAlign: 'center',
                    marginTop: '10px',
                    marginBottom: '30px',
                }}
            >
                You have successfully opted out of the Sentinel Legal multi-bureau credit search for uncovering all
                potential car finance claims over the last 15 years across all credit bureaus.
            </p>
            <span
                style={{
                    height: '2px',
                    width: '60px',
                    display: 'block',
                    background: '#b3b3b3',
                    margin: '0 auto',
                }}
            ></span>
            <p
                style={{
                    textAlign: 'center',
                    color: '#434343',
                    marginTop: '30px',
                    marginBottom: '0px',
                    fontWeight: '600',
                    letterSpacing: '1px',
                    fontSize: '15px',
                }}
            >
                If you change your mind or have any questions, please contact us at support@sentinellegal.co.uk.
            </p>
        </div>
    )
}

export default OptOutComplete
